import React from 'react';

import { useUserIsLoggedIn } from '@app/user';
import LoggedOutNav from './LoggedOutNav';
import LoggedInNav from './LoggedInNav';

const Account = () => {
  const isLoggedIn = useUserIsLoggedIn();

  if (isLoggedIn) {
    return <LoggedInNav data-testid="navbar-menu-myaccount" />;
  }

  return <LoggedOutNav data-testid="navbar-menu-myaccount" />;
};

export default Account;
